import { formatarPlaca } from 'src/app/core/utils/utilities';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EngateDesengateService } from 'src/app/services/EngateDesengateService/engateDesengate.service';
import { EntradaGateService } from 'src/app/services/EntradaGateService/entradaGate.service';
import { AgendamentoService } from 'src/app/services/AgendamentoService/agendamento.service';
import Swal from 'sweetalert2';
import { CarretaService } from 'src/app/services/CarretaService/carreta.service';
import {
  ICreateDesengateBody,
  IGetEngatesOrDesengatesParams
} from 'src/app/services/EngateDesengateService/engateDesengate.model';
import { ActivatedRoute, Router } from '@angular/router';
import { generateUUID } from 'src/app/core/generators/generateUUID';
import { CaminhaoService } from 'src/app/services/CaminhaoService/caminhao.service';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';

type IOptions = {
  name: string;
  value: any;
};

@Component({
  selector: 'app-cadastro-desengate',
  templateUrl: './cadastro-desengate.component.html',
  styleUrls: ['./cadastro-desengate.component.scss']
})
export class CadastroDesengateComponent implements OnInit {
  form: FormGroup;
  guid: string = generateUUID();
  carretasDesengatadas: string = 'Selecione';
  isEditing: boolean = false;
  isViewing: boolean = false;
  isLoading: boolean = false;

  sairOptions: IOptions[] = [];
  estacionamentoOptions: IOptions[] = [];

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private engateDesengateService: EngateDesengateService,
    private carretaService: CarretaService,
    private entradaGateService: EntradaGateService,
    private caminhaoService: CaminhaoService,
    public swalAlert: SwalAlertService
  ) {
    this.form = this.initForm();

    this.form.controls['NM_MTRT'].disabled;
  }

  ngOnInit(): void {
    this.activateRoute();
  }

  initForm(): FormGroup {
    const form = this.fb.group({
      TX_OBSV_ENGT_DSGT: [null],
      FK_CRRT_1: [null, Validators.required],
      FK_CRRT_2: [null],
      FK_CRRT_3: [null],
      NM_MTRT: [null],
      FK_GATE_ENTR: [null],
      FK_FUNC_OPER: [null, Validators.required],
      TX_PLCA_CAVA: [null, Validators.required],
      FK_AGND: [null, Validators.required],
      TX_ESTC: ['Nenhuma carreta'],
      PLCA_DSGT: [null]
    });
    return form;
  }

  saveDesengate(): void {
    if (!this.isEditing) {
      this.postDesengate();
    }
    if (this.isEditing) {
    }
  }

  postDesengate(): void {
    this.isLoading = true;
    const payload = this.createPayload();
    this.engateDesengateService.CreateDesengate(payload, this.guid).subscribe({
      next: () => {
        this.router.navigate(['listagem/desengates']);
        this.isLoading = false;
      },
      error: () => (this.isLoading = false)
    });
  }

  getAgendamento(): void {
    const placaCavalo = this.form.controls['TX_PLCA_CAVA'].value;
    const numeroAgendamento = this.form.controls['FK_AGND'].value;

    if (!placaCavalo && !numeroAgendamento) return;

    this.isLoading = true;
    this.caminhaoService
      .GetLastVersionCaminhaoInfoByEntradaOrAgendamentoOrPlaca(
        null,
        numeroAgendamento,
        placaCavalo
      )
      .subscribe({
        next: async (response: any) => {
          if (!response) {
            this.swalAlert.showAlert(
              'Atenção!',
              'Agendamento não encontrado.',
              'warning'
            );
            this.isLoading = false;
            return;
          }

          const data = response;
          this.form.controls['FK_AGND'].setValue(data.FK_AGND);
          this.form.controls['TX_PLCA_CAVA'].setValue(data.TX_PLCA_CAVA);
          this.form.controls['FK_FUNC_OPER'].setValue(data.FK_FUNC_OPER);
          this.form.controls['NM_MTRT'].setValue(
            data.NM_USUA_MTRT ?? data.NM_MTRT
          );

          const FK_FUNC_OPER = localStorage.getItem('id');
          this.form.controls['FK_FUNC_OPER'].setValue(FK_FUNC_OPER);
          this.getGateEntradaId(data.TX_PLCA_CAVA);

          const carretaOptions = await Promise.all([
            this.getCarretaIdByPlaca(data.TX_PLCA_CRRT1),
            this.getCarretaIdByPlaca(data.TX_PLCA_CRRT2),
            this.getCarretaIdByPlaca(data.TX_PLCA_CRRT3)
          ]);

          this.sairOptions = [
            {
              name: formatarPlaca(data.TX_PLCA_CRRT1),
              value: carretaOptions[0]
            },
            {
              name: formatarPlaca(data.TX_PLCA_CRRT2),
              value: carretaOptions[1]
            },
            {
              name: formatarPlaca(data.TX_PLCA_CRRT3),
              value: carretaOptions[2]
            }
          ];
          this.onSairChange([]);
          this.isLoading = false;
        },
        error: () => {
          this.isLoading = false;
        },
        complete: () => {
          this.isLoading = false;
        }
      });
  }

  async getCarretaIdByPlaca(placa: string): Promise<number> {
    this.isLoading = true;
    return new Promise((resolve, reject) => {
      this.carretaService.GetCarreta({ placa }).subscribe({
        next: res => {
          const data = res.ITEMS[0];
          const carretaId = data ? data.PK_CRRT : 0;
          this.isLoading = false;
          resolve(carretaId);
        },
        error: err => {
          this.isLoading = false;
          reject(0);
        }
      });
    });
  }

  async getGateEntradaId(TX_PLCA_CAVA: string): Promise<void> {
    this.isLoading = true;
    const placaCavalo = TX_PLCA_CAVA;
    await this.entradaGateService.GetEntradasGate({ placaCavalo }).subscribe({
      next: res => {
        const data = res.ITEMS[0];
        this.form.controls['FK_GATE_ENTR'].setValue(data.PK_GATE_ENTR);
        this.isLoading = false;
      },
      error: err => {
        this.isLoading = false;
      }
    });
  }

  onSairChange(event: any): void {
    this.form.controls['FK_CRRT_1'].reset();
    this.form.controls['FK_CRRT_2'].reset();
    this.form.controls['FK_CRRT_3'].reset();

    if (!event.length) {
      const selecionadas = this.sairOptions
        .filter(x => event.includes(x.value) && x.value)
        .map(x => x.name)
        .join(' | ');
      this.carretasDesengatadas = selecionadas.length
        ? selecionadas
        : 'Selecione';

      const naoSelecionadas = this.sairOptions
        .filter(option => !event.includes(option.value) && option.value)
        .map(option => option.name)
        .join(' | ');
      this.form.controls['TX_ESTC'].setValue(
        naoSelecionadas.length ? naoSelecionadas : 'Nenhuma carreta'
      );
      return;
    }

    switch (event.length) {
      case 1:
        this.form.controls['FK_CRRT_1'].setValue(event[0]);
        this.form.controls['FK_CRRT_2'].reset();
        this.form.controls['FK_CRRT_3'].reset();
        break;
      case 2:
        this.form.controls['FK_CRRT_1'].setValue(event[0]);
        this.form.controls['FK_CRRT_2'].setValue(event[1]);
        this.form.controls['FK_CRRT_3'].reset();
        break;
      case 3:
        this.form.controls['FK_CRRT_1'].setValue(event[0]);
        this.form.controls['FK_CRRT_2'].setValue(event[1]);
        this.form.controls['FK_CRRT_3'].setValue(event[2]);
        break;
      default:
        break;
    }

    const selecionadas = this.sairOptions
      .filter(x => event.includes(x.value) && x.value)
      .map(x => x.name)
      .join(' | ');
    this.carretasDesengatadas = selecionadas.length
      ? selecionadas
      : 'Selecione';

    const naoSelecionadas = this.sairOptions
      .filter(option => !event.includes(option.value) && option.value)
      .map(option => option.name)
      .join(' | ');
    this.form.controls['TX_ESTC'].setValue(
      naoSelecionadas.length ? naoSelecionadas : 'Nenhuma carreta'
    );
  }

  createPayload(): ICreateDesengateBody {
    return {
      TX_OBSV_ENGT_DSGT: this.form.controls['TX_OBSV_ENGT_DSGT'].value,
      FK_CRRT_1: this.form.controls['FK_CRRT_1'].value,
      FK_CRRT_2: this.form.controls['FK_CRRT_2'].value,
      FK_CRRT_3: this.form.controls['FK_CRRT_3'].value,
      FK_FUNC_OPER: Number(this.form.controls['FK_FUNC_OPER'].value),
      FK_GATE_ENTR: this.form.controls['FK_GATE_ENTR'].value,
      TX_PLCA_CAVA: String(
        this.form.controls['TX_PLCA_CAVA'].value
      ).toUpperCase(),
      FK_AGND: this.form.controls['FK_AGND'].value
    };
  }

  clearForms(): void {
    const placaCavalo = this.form.controls['TX_PLCA_CAVA'].value;
    if (!placaCavalo) {
      this.form.controls['FK_AGND'].reset();
      this.form.reset();
    }
  }

  activateRoute(): void {
    this.route.queryParams.subscribe(params => {
      if (params['idDesengate'] && params['isViewing'] === 'true') {
        this.isViewing = true;
        this.form.disable();
        const PK_ENGT_DSGT = params['idDesengate'];
        this.engateDesengateService
          .GetEngateDesengateInfoById(PK_ENGT_DSGT)
          .subscribe({
            next: res => {
              this.form.controls['FK_AGND'].setValue(res.FK_AGND);
              this.form.controls['TX_PLCA_CAVA'].setValue(res.TX_PLCA_CAVA);
              this.form.controls['NM_MTRT'].setValue(res.NM_MTRT);
              const valuesDsgt = [
                res.TX_PLCA_CRRT1,
                res.TX_PLCA_CRRT2,
                res.TX_PLCA_CRRT3
              ].filter(val => val);
              this.form.controls['PLCA_DSGT'].setValue(valuesDsgt.join(' ; '));
              const valuesEstc = [
                res.TX_PLCA_CRRT1_DIFF,
                res.TX_PLCA_CRRT2_DIFF,
                res.TX_PLCA_CRRT3_DIFF
              ].filter(val => val);
              this.form.controls['TX_ESTC'].setValue(valuesEstc.join(' ; '));
              this.form.controls['TX_OBSV_ENGT_DSGT'].setValue(
                res.TX_OBSV_ENGT_DSGT
              );
            },
            error: err => {
              if (err?.handled) {
                this.router.navigate(['listagem/desengates']);
                return;
              }
              this.swalAlert.showAlertOnConfirmNavigate(
                'Erro!',
                'Erro ao buscar o desengate.',
                'error',
                'listagem/desengates'
              );
            },
            complete: () => {
              this.isLoading = false;
            }
          });
      }
    });
  }
}
